//
//  [アドイン] 編集モーダルで画像選択用の画像一覧表示（サーバー対応）
//
// ./ImagePickerModal.js
//

import React, { useEffect, useState } from 'react';
import { useEscapeClose } from '../hooks/useEscapeClose';


function ImagePickerModal({ onSelect, onClose }) {
  const [imageList, setImageList] = useState([]);

  useEscapeClose(onClose); // ←Escキーでモーダル閉じる

  useEffect(() => {
    fetch("https://newells4610.stars.ne.jp/api/image_list.php")
      .then((res) => res.json())
      .then((list) => setImageList(list.sort((a, b) => a.localeCompare(b))))
      .catch((err) => {
        console.error("画像一覧取得エラー:", err);
        setImageList([]);
      });
  }, []);

  return (
    <div className="modal-overlay" style={{ zIndex: 9000 }}>
      <div className="modal-box" style={{ maxWidth: 600, maxHeight: '80vh', overflowY: 'auto' }}>
        <h4 style={{ marginBottom: 12 }}>画像を選んでください</h4>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
          {imageList.map((filename, i) => (
            <div key={i} style={{ textAlign: 'center', width: '100px' }}>
              <img
                src={`/images/${filename}`}
                alt={filename}
                width="100"
                style={{
                  cursor: 'pointer',
                  border: '1px solid #ccc',
                  borderRadius: '6px',
                  boxShadow: '1px 1px 3px rgba(0,0,0,0.2)',
                }}
                onClick={() => onSelect(`/images/${filename}`)}
              />
              <div style={{ fontSize: '12px', marginTop: '4px' }}>{filename}</div>
            </div>
          ))}
        </div>
        <div className="modal-actions" style={{ marginTop: '1em', textAlign: 'right' }}>
          <button onClick={onClose}>キャンセル</button>
        </div>
      </div>
    </div>
  );
}

export default ImagePickerModal;
